<template>
  <div>
    <v-row class="header-state-view">
      <v-col cols="12" class="py-0">
        <v-card-title class="py-3 headline white--text" primary-title>
          Status -
          {{ stateViewInfo.record.messageInfo.senderId }}
          / {{ stateViewInfo.record.messageInfo.recipientId }} /
          {{ stateViewInfo.record.messageInfo.messageName }} -
          {{ stateViewInfo.processId }}
        </v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card class="px-6 pt-6 pb-0 dialog-container">
          <v-card-text class="pa-0">
            <v-row class="no-gutters mt-0">
              <v-col cols="12">
                <v-row class="mt-0 status-section-mb">
                  <v-col
                    cols="12"
                    sm="2"
                    :class="[
                      'pr-0 pt-0 pb-0',
                      $vuetify.theme.dark ? '' : 'gray--text font-semibold',
                    ]"
                  >
                    Sender :
                    <span :class="$vuetify.theme.dark ? '' : 'black--text'">{{
                      stateViewInfo.record.messageInfo.senderId
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    :class="[
                      'pr-0 pt-0 pb-0',
                      $vuetify.theme.dark ? '' : 'gray--text font-semibold',
                    ]"
                  >
                    Receiver :
                    <span :class="$vuetify.theme.dark ? '' : 'black--text'">
                      {{ stateViewInfo.record.messageInfo.recipientId }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    :class="[
                      'pr-0 pt-0 pb-0',
                      $vuetify.theme.dark ? '' : 'gray--text font-semibold',
                    ]"
                  >
                    Message :
                    <span :class="$vuetify.theme.dark ? '' : 'black--text'">
                      {{ stateViewInfo.record.messageInfo.messageName }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    :class="[
                      'pr-0 pt-0 pb-0',
                      $vuetify.theme.dark ? '' : 'gray--text font-semibold',
                    ]"
                  >
                    Partner :
                    <span :class="$vuetify.theme.dark ? '' : 'black--text'">{{
                      stateViewInfo.partnerName
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    :class="[
                      'pr-0 pt-0 pb-0',
                      $vuetify.theme.dark ? '' : 'gray--text font-semibold',
                    ]"
                  >
                    Direction :
                    <span :class="$vuetify.theme.dark ? '' : 'black--text'">{{
                      directionText(stateViewInfo.direction)
                    }}</span>
                  </v-col>
                  <!-- <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0"></v-col> -->
                </v-row>
                <v-row class="mt-0 status-section-mb">
                  <v-col
                    cols="12"
                    :class="['pt-0 pb-0', $vuetify.theme.dark ? '' : 'gray--text font-semibold']"
                  >
                    Status :
                    <span>
                      <font :color="statusColor(stateViewInfo.transactionCode)">{{
                        statusText(stateViewInfo.transactionCode)
                      }}</font>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <div id="process-table-area">
              <v-row class="ma-0">
                <system-progress
                  :sysloading="isLoading"
                  :sysloadingTitle="sysloadingTitle"
                ></system-progress>
                <v-col cols="12" :class="$vuetify.theme.dark ? '' : 'pa-0'">
                  <v-data-table
                    :headers="headers"
                    :items="listData"
                    class="list-table monitor-state-view"
                    :height="480"
                    :fixed-header="true"
                    hide-default-footer
                    :items-per-page="100"
                    group-by="processSetupName"
                    group-desc
                  >
                    <template v-slot:item.procSetupSeq="{ item }">
                      <div class="index-col">{{ item.INDEX }}</div>
                    </template>
                    <template
                      v-slot:group.header="{
                        group,
                        items,
                        isOpen,
                        toggle,
                        remove,
                      }"
                    >
                      <td colspan="8">
                        <v-btn
                          icon
                          @click="toggle"
                          :class="$vuetify.theme.dark ? '' : 'ml-2 mr-3 custom-btn-expand'"
                          :style="$vuetify.theme.dark ? '' : 'width: 24px; height: 24px;'"
                        >
                          <v-icon v-if="isOpen" small>mdi-minus</v-icon>
                          <v-icon v-else small>mdi-plus</v-icon>
                        </v-btn>
                        <span
                          style="font-size: 14px"
                          :class="$vuetify.theme.dark ? '' : 'font-semibold'"
                          >{{ group }}</span
                        >
                      </td>
                    </template>
                    <template v-slot:item.procType="{ item }">
                      <v-btn
                        v-if="item.procType.indexOf(`COM`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <icon-svg
                          v-if="item.procType.indexOf(`COM`) !== -1"
                          :size="procIconSize"
                          iconName="proc-comm"
                        />
                      </v-btn>
                      <v-btn
                        v-if="item.procType.indexOf(`DBA`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <icon-svg
                          v-if="item.procType.indexOf(`DBA`) !== -1"
                          :size="procIconSize"
                          iconName="proc-dsm"
                        />
                      </v-btn>
                      <v-btn
                        v-if="item.procType.indexOf(`DIR`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <icon-svg
                          v-if="item.procType.indexOf(`DIR`) !== -1"
                          :size="procIconSize"
                          iconName="proc-folder"
                        />
                      </v-btn>

                      <v-btn
                        v-if="item.procType.indexOf(`SET`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <v-icon v-if="item.procType.indexOf(`SET`) !== -1" small>fa fa-gift</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="item.procType.indexOf(`MAP`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <icon-svg
                          v-if="item.procType.indexOf(`MAP`) !== -1"
                          :size="procIconSize"
                          iconName="proc-mapper"
                        />
                      </v-btn>
                      <v-btn
                        v-if="item.procType.indexOf(`TRIG`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                      >
                        <icon-svg
                          v-if="item.procType.indexOf(`TRIG`) !== -1"
                          :size="procIconSize"
                          iconName="proc-trigger"
                        />
                      </v-btn>
                      <v-btn
                        v-if="item.procType.indexOf(`ENV`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc-envel darken-1"
                        height="30"
                      >
                        <v-icon v-if="item.procType.indexOf(`ENV`) !== -1" small
                          >fa fa-envelope</v-icon
                        >
                      </v-btn>
                      <v-btn
                        v-if="item.procType.indexOf(`MQ`) !== -1"
                        class="mr-1"
                        x-small
                        color="proc darken-1"
                        height="30"
                        style="width: 44px"
                        >mq</v-btn
                      >
                    </template>

                    <template v-slot:item.transactionCode="{ item }">
                      <span
                        v-if="
                          item.procType.indexOf(`MAP`) !== -1 &&
                            item.transactionCode != 'TRANS_O_FAIL'
                        "
                        class="font-semibold"
                        v-html="statusTextMap(item)"
                      ></span>
                      <span class="font-semibold" v-else>
                        <font :color="statusColor_list(item.transactionCode, item.errorMessage)">
                          {{ statusText_list(item.transactionCode, item.errorMessage) }}
                        </font>
                      </span>
                    </template>
                    <template v-slot:item.fileLink="{ item }">
                      <span
                        v-if="
                          item.procType.indexOf(`MAP`) !== -1 &&
                            item.transactionCode != 'TRANS_O_FAIL'
                        "
                      >
                        <p>
                          <a
                            class="link-file-text cursor-pointer layout-col font-semibold"
                            @click="openDataInformationFileViewWindow(item, 0)"
                            >{{ $t('btn.common.view') }}</a
                          >
                        </p>
                        <p>
                          <a
                            class="link-file-text cursor-pointer layout-col font-semibold"
                            @click="openDataInformationFileViewWindow(item, 1)"
                            >{{ $t('btn.common.view') }}</a
                          >
                        </p>
                      </span>
                      <span v-else>
                        <a
                          v-if="item.fileLink !== undefined"
                          class="link-file-text cursor-pointer layout-col font-semibold"
                          @click="openDataInformationFileViewWindow(item)"
                          >{{ $t('btn.common.view') }}</a
                        >
                      </span>
                    </template>

                    <template v-slot:item.reProcess="{ item }">
                      <span
                        v-if="
                          item.procType.indexOf(`MAP`) !== -1 &&
                            item.transactionCode != 'TRANS_O_FAIL'
                        "
                      >
                        <p>
                          <a @click="executeReProcess(item, 0)"
                            ><v-icon small class="mr-1">mdi-play-box-outline</v-icon></a
                          >
                        </p>
                        <p>
                          <a @click="executeReProcess(item, 1)"
                            ><v-icon small class="mr-1">mdi-play-box-outline</v-icon></a
                          >
                        </p>
                      </span>
                      <span v-else>
                        <a @click="executeReProcess(item)">
                          <v-icon small class="mr-1">mdi-play-box-outline</v-icon>
                        </a>
                      </span>
                    </template>
                    <template v-slot:item.procCommId="{ item }">
                      <span v-if="item.procType.indexOf(`COM`) !== -1">
                        {{ item.host_port }}
                      </span>
                      <span v-if="item.procType.indexOf(`DBA`) !== -1">
                        {{ item.dbAdptName }}
                      </span>
                      <span v-if="item.procType.indexOf(`DIR`) !== -1">
                        {{ item.foldNm }}
                      </span>
                      <span v-if="item.procType.indexOf(`TRIG`) !== -1">
                        {{ item.procName }}
                      </span>
                      <span v-if="item.procType.indexOf(`MAP`) !== -1" v-html="item.mappingName">
                      </span>
                      <span v-if="item.procType.indexOf(`MQ`) !== -1">
                        {{ item.mqName }}
                      </span>
                    </template>
                    <template v-slot:item.timestamp="{ item }">
                      <span
                        v-if="
                          item.procType.indexOf(`MAP`) !== -1 &&
                            item.transactionCode != 'TRANS_O_FAIL'
                        "
                        v-html="gmtTimeZoneMap(item.timestamp)"
                      ></span>
                      <span v-else>
                        <font v-if="item.timestamp !== undefined">{{
                          applyGmtTimeZone(item.timestamp)
                        }}</font>
                      </span>
                    </template>
                    <template v-slot:item.errorMessage="{ item }">
                      <span>
                        <font v-if="item.errorMessage !== undefined">{{ item.errorMessage }}</font>
                      </span>
                    </template>
                    -->
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider class="deviderColor mt-5"></v-divider>
          <v-row class="ml-0 mr-0 merge-button-group">
            <v-col class="mt-1 button-col action-col pa-0" lg="12">
              <div class="btn-form-control text-right pb-3">
                <v-btn class="btn btn-delete" @click="closeWindow('btn-close')">
                  <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
                  {{ $t('btn.common.close') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <dialogWindow
      ref="reProcess"
      size="max"
      :detail="reProcessContent"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="repocessCheckDialog"
      size="max"
      :detail="$t('msg.monitoring.reprocessCheck')"
      color="confirmation"
      :show-cancel="true"
      @select-ok="_executeReProcess(reprocessItem, reprocessIndex)"
    ></dialogWindow>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { openWindow } from '@/vue-dlb/utils/window-opener';

const moment = require('moment');

export default {
  components: {
    SystemProgress,
    IconSvg,
    dialogWindow,
  },
  name: 'monitoring-err-view-window',

  data() {
    return {
      headers: [
        {
          text: this.$t('tbl.common.columnNo'),
          value: 'procSetupSeq',
          width: '40px',
          sortable: false,
        },
        {
          text: 'Comp.',
          value: 'procType',
          align: 'center',
          width: '60px',
          sortable: false,
        },
        {
          text: 'Route Info.',
          value: 'procCommId',
          width: '280px',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'transactionCode',
          align: 'center',
          width: '50px',
          sortable: false,
        },
        {
          text: 'Processed Date',
          value: 'timestamp',
          align: 'center',
          width: '130px',
          sortable: false,
        },
        {
          text: 'Error Message',
          value: 'errorMessage',
          width: '220px',
          sortable: false,
        },
        {
          text: 'Data Info.',
          value: 'fileLink',
          align: 'center',
          width: '70px',
          sortable: false,
        },
        {
          text: 'Re-process',
          value: 'reProcess',
          align: 'center',
          width: '80px',
          sortable: false,
        },
      ],
      reprocessItem: {},
      reprocessIndex: 0,
      listData: [],
      tmpListData: [],
      masterSearchItems: {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
          },
        ],
      },
      mapItem: [],
      procIconSize: 24,
      stateViewInfo: {},
      isClick: true,
      processViewArr: [],
      gmtTmzn: '',
      reProcessContent: '',
    };
  },

  computed: {
    ...mapState('common', {
      CommMsgList: 'CommMsgList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
  },
  watch: {
    listData() {
      return this.listData;
    },
  },

  methods: {
    initialize() {
      this.isLoading = true;
      this.gmtTmzn = this.$cookies.get('gmt-timezone');

      if ($cookies.get('ownr-id') === $cookies.get('login-user-comp-id')) {
        this.masterSearchItems.data[0].ADMIN_YN = 'Y';
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('login-user-comp-id');
      } else {
        this.masterSearchItems.data[0].ADMIN_YN = 'N';
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      }

      this.$store
        .dispatch('getStateViewPopupListInfo', this.stateViewInfo)
        .then(async () => {
          this.tmpListData = this.$store.getters.stateViewPopupListInfo;
          await Store.dispatch('map/queryMapListByProcSetup', this.masterSearchItems);

          for (let i = 0; i < this.tmpListData.length; i++) {
            for (let j = 0; j < this.mapList.length; j++) {
              if (
                this.tmpListData[i].procType === 'MAP' &&
                this.tmpListData[i].procCommId === this.mapList[j].MAP_PRCS_NO
              ) {
                this.tmpListData[i].mappingName = this.tmpListData[i].mappingName.replaceAll(
                  '$',
                  this.mapList[j].MAPPINGNAME,
                );
              }
            }
          }

          this.listData = this.tmpListData;
          this.isLoading = false;
          // console.log("listData : " + JSON.stringify(this.listData));
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },

    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },

    statusColor(status) {
      if (status.indexOf('SEND_O_DONE') !== -1) return '#2a8c72';
      else if (status.indexOf('FAIL') !== -1) return '#EB1E50';
      else if (status.indexOf(undefined) !== -1) return '#EB1E50';
      else return '#6F5ECE';
    },

    statusText(status) {
      if (status.indexOf('SEND_O_DONE') !== -1) return 'OK';
      else if (status.indexOf('FAIL') !== -1) return 'Error';
      else if (status.indexOf(undefined) !== -1) return 'Unknown';
      else return 'Processing';
    },

    statusColor_list(status, errMsg) {
      if (status !== undefined) {
        if (
          (status.indexOf('DONE') !== -1 && (errMsg === undefined || errMsg === '')) ||
          status.indexOf('SEND_O_DONE') !== -1
        )
          return '#2a8c72';
        else if (status.indexOf('FAIL') !== -1 || (errMsg !== undefined && errMsg !== ''))
          return '#EB1E50';
        else if (status.indexOf(undefined) !== -1) return '#EB1E50';
        else return '#6F5ECE';
      }
    },
    statusTextMap(item) {
      let text = this.statusText_list(item.transactionCode, item.errorMessage);
      let color = this.statusColor_list(item.transactionCode, item.errorMessage);
      return `<p><font color="${color}">${text}</font></p><p><font color="${color}">${text}</font></p>`;
    },
    gmtTimeZoneMap(data) {
      let timestamp = data.split('|');
      return `<p><font>${this.applyGmtTimeZone(
        timestamp[0],
      )}</font></p><p><font>${this.applyGmtTimeZone(timestamp[1])}</font></p>`;
    },
    statusText_list(status, errMsg) {
      if (status !== undefined) {
        if (
          (status.indexOf('DONE') !== -1 && (errMsg === undefined || errMsg === '')) ||
          status.indexOf('SEND_O_DONE') !== -1
        )
          return 'OK';
        else if (status.indexOf('FAIL') !== -1 || (errMsg !== undefined && errMsg !== ''))
          return 'Error';
        else if (status.indexOf(undefined) !== -1) return 'Unknown';
        else return 'Processing';
      }
    },

    directionText(direction) {
      if (direction === 'I') return 'Inbound';
      else if (direction === 'O') return 'Outbound';
    },

    applyGmtTimeZone(date) {
      let newM = '';
      if (date !== undefined && date !== '') {
        newM = moment(date)
          .add(this.gmtTmzn, 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },
    openDataInformationFileViewWindow(rowItem, index = -1) {
      let item = {
        userId: this.stateViewInfo.userId,
        groupId: this.stateViewInfo.groupId,
        processId: this.stateViewInfo.processId,
        senderId: this.stateViewInfo.record.messageInfo.senderId,
        recipientId: this.stateViewInfo.record.messageInfo.recipientId,
        partnerName: this.stateViewInfo.partnerName,
        messageName: this.stateViewInfo.record.messageInfo.messageName,
        direction: this.stateViewInfo.direction,
        data: this.stateViewInfo.data,
        record: this.stateViewInfo.record,
        recordId: index > -1 ? rowItem.recordId.split('|')[index] : rowItem.recordId,
        fileLink: index > -1 ? rowItem.fileLink.split('|')[index] : rowItem.fileLink,
        userData:
          index > -1 ? rowItem.userData.split('|')[index] : JSON.stringify(rowItem.userData),
        dataTrans: index > -1 ? JSON.parse(rowItem.data.split('|')[index]) : rowItem.data,
      };

      const type = 'FileView';
      const params = {
        ROWID: item.recordId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.recordId.toString(),
          auth: this.$auth,
        },
      };
      item.id = item.recordId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringDataInfoFileView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=721,left=250,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },

    findIndexItem(arrView, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row.item[prop] === arrView.item[prop] && row.type === arrView.type;
      });
      return index > -1 ? index : null;
    },
    _executeReProcess(item, index) {
      this.$store
        .dispatch('execReTranslation', {
          data: index > -1 ? JSON.parse(item.data.split('|')[index]) : item.data,
        })
        .then(() => {
          this.reProcessContent = 'ReTranslation is complete.';
          this.$refs.reProcess.dialog = true;
        });
    },
    executeReProcess(rowItem, index = -1) {
      // console.log("Khanh check", index > -1 ? JSON.parse(rowItem.data.split('|')[index]) : rowItem.data)
      if (rowItem.versionCheckFlag != 'S') {
        this.reprocessItem = Object.assign({}, rowItem);
        this.reprocessIndex = index;
        this.$refs.repocessCheckDialog.dialog = true;
      } else {
        this.$store
          .dispatch('execReTranslation', {
            data: index > -1 ? JSON.parse(rowItem.data.split('|')[index]) : rowItem.data,
          })
          .then(() => {
            this.reProcessContent = 'ReTranslation is complete.';
            this.$refs.reProcess.dialog = true;
          });
      }
    },
  },

  created() {
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.stateViewInfo = param['options'].dataValue;
    this.$auth = param['options'].auth;
    this.initialize();
  },
};
</script>

<style scoped>
.monitor-err-layout-dialog {
  width: 1200px;
}
.monitor-err-layout-dialog .v-card__text {
  font-size: 13px;
  line-height: 19px;
}
.status-section-dialog {
  padding: 20px 10px 15px 10px;
}
.status-section-mb {
  margin-bottom: 10px;
}
.status-text-mb {
  margin-bottom: 5px;
}
div.v-card__title.status-headline {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: #0082ba;
  margin-bottom: 10px;
}
.theme--light .monitor-err-layout-dialog .dialog-body .v-sheet {
  background-color: #ffffff;
  border-left: none !important;
}
.theme--light .monitor-err-layout-dialog .dialog-body .status-section-dialog.v-sheet {
  background: #fafcff;
  border: 1px solid #f0f7fb;
}
.theme--light span {
  font-family: Open Sans;
  font-style: normal;
  /* color:#000000; */
}
.theme--dark span {
  font-family: Open Sans;
  font-style: normal;
  color: #ffffff;
}
.theme--dark .monitor-err-layout-dialog .dialog-body .v-sheet {
  background-color: #292c35;
  border-left: none !important;
}
.theme--dark .monitor-err-layout-dialog .dialog-body .status-section-dialog.v-sheet {
  background-color: #292c35;
  border-left: none !important;
}

#process-table-area {
  text-align: initial;
  position: relative;
  width: 100%;
  height: 500px;
  border: 3px solid #4e686f !important;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.list-table tbody tr td span {
  font-size: 12px;
}
a.link-file-text.cursor-pointer.layout-col {
  font-size: 12px;
}
</style>
